import debounce from 'lodash.debounce';
import { toast } from 'react-toastify';
import type { ToastOptions } from 'react-toastify';
import Notification, { Translation, TranslationOption } from '.';

const wait = 1000;
export const closeDelay = 3000;
const debounceOptions = { leading: true, trailing: false };

type NotificationOption = {
  i18nKey: string;
  i18nMessageKey?: string;
  i18nMessageKeyCount?: number;
  action?: () => void;
  i18nActionKey?: string;
  autoCloseDelay?: ToastOptions['autoClose'];
  translation?: Translation;
  variant?: ToastOptions['type'];
  translationOption?: TranslationOption;
};

const broadcastNotification = debounce(
  ({
    i18nKey,
    i18nMessageKey,
    i18nMessageKeyCount,
    i18nActionKey,
    action,
    variant = 'info',
    translation,
    translationOption,
    autoCloseDelay,
  }: NotificationOption): void => {
    toast.dismiss();
    toast(
      <Notification
        translation={translation}
        headingKey={i18nKey}
        messageKey={i18nMessageKey}
        messageKeyCount={i18nMessageKeyCount}
        action={action}
        actionKey={i18nActionKey}
        translationOptions={translationOption}
      />,
      {
        autoClose: autoCloseDelay ?? closeDelay,
        type: variant,
      },
    );
  },
  wait,
  debounceOptions,
);

export default broadcastNotification;
